export default function HalfCircleMosaic() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2413_1803)">
                <rect width="100%" height="100%" fill="#01B4EE" />
                <path d="M500 0C776.142 0 1000 223.857 1000 500C1000 776.143 776.142 1000 500 1000V0Z" fill="#FFC525" />
                <path d="M0 0C276.142 0 500 223.857 500 500C500 776.143 276.142 1000 0 1000V0Z" fill="#FFC525" />
            </g>
            <defs>
                <clipPath id="clip0_2413_1803">
                    <rect width="100%" height="100%" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}